import {ServiceHosts} from "../common/ServiceHosts";
import {FeedFormat} from "../feed/FeedTypes";
import {BaseConverter} from "../util/string/BaseConverter";


class FeedLinker {
    private HostName: string;
    protected cId: number;
    protected playerId: number;
    private feedId: number;

    constructor(cId: number, playerId: number, feedId: number, isReseller: boolean) {
        this.cId = cId;
        this.playerId = playerId;
        this.feedId = feedId;
        this.HostName = isReseller ? ServiceHosts.content.reseller : ServiceHosts.content.streamhoster;
    }

    private urlEncodeQSArray(qsArray: string[][]): string {
        return qsArray
            .map(qsPair => encodeURIComponent(qsPair[0]) + "=" + encodeURIComponent(qsPair[1]))
            .join("&");
    }

    getFeedUrl(feedFormat: FeedFormat): string {
        const bcInt = BaseConverter.createIntConverter();
        const bcLong = BaseConverter.createLongConverter();
        return this.getUrl(`feed/${bcInt.getStr(this.cId)}/${bcLong.getStr(this.playerId)}/${bcLong.getStr(this.feedId)}`, [["format", this.getFormatQueryValue(feedFormat)]]);
    }

    private getFormatQueryValue(format: FeedFormat): string {
        switch (format) {
            case FeedFormat.Mrss:
                return FeedFormat.Mrss.toLowerCase().toString();
            case FeedFormat.Roku:
                return "rokujson";
            case FeedFormat.FireTV:
                return FeedFormat.FireTV.toLowerCase().toString();
            case FeedFormat.ITunes:
                return FeedFormat.ITunes.toLowerCase().toString();
            default:
                console.log(`Unsupported feed format: ${format}`);
                return FeedFormat.Mrss.toLowerCase().toString();

        }
    }

    protected getUrl(uriStem: string, qsArray: string[][]): string {
        const uriWithoutQS = `https://${this.HostName}/${uriStem}`;
        const uriWithQS = qsArray.length > 0 ? `${uriWithoutQS}?${this.urlEncodeQSArray(qsArray)}` : uriWithoutQS;
        return uriWithQS;
    }


}

export {FeedLinker}